import type ModelCollectionTrade  from "./common/model/ModelCollectionTrade"
import type TradeOffer  from "./common/model/Types/TradeOffer"
import Currency, {E_CURRENCY_TYPE}  from "./common/model/Types/Currency"

/*
    содержит
    tradesGift:     Array<TradeOffer>    
    tradesBuyCoin:  Array<TradeOffer>    
    tradesBuyDesk:  Array<TradeOffer>    
    tradesBuyChips: Array<TradeOffer>    

    notifyCount:number

    как пользоваться: 

    notifyCount выводишь в navbar
    
    выводишь  tradesGift в окно подарка
        проверить доступно ли можно так
        let serverTimestamp = modelListTrade.getTimestamp();
        lists.tradesGift.forEach(trade => {
            let available = trade.isTimeAvailable(serverTimestamp);
            console.log("Gift "+trade.uuid+" avalaible = "+available); 
        });

    выводишь  tradesBuyCoin   в окно покупки монет
    выводишь  tradesBuyDesk   в окно покупки досок
    выводишь  tradesBuyChips  в окно покупки фишек    
*/

export default class ArraySortedTrade {
    tradesAll:ModelCollectionTrade

    tradesGift:     Array<TradeOffer>    
    tradesBuyCoin:  Array<TradeOffer>    
    tradesBuyDesk:  Array<TradeOffer>    
    tradesBuyChips: Array<TradeOffer>    

    
    notifyCount:number    

    //TournamentsAnnounced: Array<Tournament>
    
    constructor(trades:ModelCollectionTrade) {
        this.tradesAll = trades;
        this.notifyCount = 0;
        this.tradesGift = [];        
        this.tradesBuyCoin = [];
        this.tradesBuyDesk = [];
        this.tradesBuyChips = [];                               
    }

    clear() {
        this.notifyCount = 0;
        this.tradesGift = [];        
        this.tradesBuyCoin = [];
        this.tradesBuyDesk = [];
        this.tradesBuyChips = [];     
    }

    update(trades:ModelCollectionTrade, serverTimestamp:number) {
        this.clear();        
        trades.forEachAsync( (trade) => {                                
            if(trade.isGift()) 
                this.tradesGift.push(trade);

            if(trade.isSystemCoin()) 
                this.tradesBuyCoin.push(trade);

            if(trade.isSystemItem())  {
                let currencyTo = trade.currencyTo;
                if(currencyTo.type_id == E_CURRENCY_TYPE.CHIPS)
                    this.tradesBuyChips.push(trade);

                if(currencyTo.type_id == E_CURRENCY_TYPE.DESK)
                    this.tradesBuyDesk.push(trade);
            }                
        });        

        this.notifyCount = this.tradesGift.reduce( (value, gift) => value + (gift.isTimeAvailable(serverTimestamp)? 1:0), 0);
    }     



    printout( log: (...args:Array<any>)=>void ) {        
        log("tradesGift:");               this.printArray(log, this.tradesGift);
        log("tradesBuyCoin:");            this.printArray(log, this.tradesBuyCoin);
        log("tradesBuyChips:");           this.printArray(log, this.tradesBuyChips);                        
        log("tradesBuyDesk:");            this.printArray(log, this.tradesBuyDesk);                       
    }

    printArray( log: (...args:Array<any>)=>void , models:Array<TradeOffer>) {
        models.forEach( (tournament) => {
            this.printTrade(log, tournament);
        });        
    }

    printTrade( log: (...args:Array<any>) => void, trade:TradeOffer) {
        log("Trade "+trade.uuid+" type string = "+trade.typeString+" ");
    }

}